import React from 'react';
import { ChevronDownIcon } from '@heroicons/react/24/outline';

interface RoomSectionHeaderProps {
  label: string;
  count?: number;
  open: boolean;
  onToggle: () => void;
  trailing?: React.ReactNode;
}

/**
 * Collapsible section header used inside the room-info panel. Matches Figma
 * `4029:196974` — 40 px tall gray neutral bar with uppercase Poppins-Bold
 * 12 px label and a rotating chevron on the right.
 */
const RoomSectionHeader: React.FC<RoomSectionHeaderProps> = ({
  label,
  count,
  open,
  onToggle,
  trailing,
}) => {
  return (
    <button
      type="button"
      onClick={onToggle}
      className="w-full h-10 flex items-center pl-4 pr-3 bg-neutral-200/60 dark:bg-neutral-800/40 text-text-secondary hover:bg-neutral-200 dark:hover:bg-neutral-800/60 transition-colors"
      aria-expanded={open}
    >
      <span className="flex-1 text-left text-[12px] font-bold uppercase tracking-wide">
        {label}
        {count !== undefined && ` (${count})`}
      </span>
      {trailing}
      <ChevronDownIcon
        className={`w-4 h-4 ml-1 transition-transform ${open ? '' : '-rotate-90'}`}
      />
    </button>
  );
};

export default RoomSectionHeader;
